const REVIEWS_AR = [
  {
    name: 'أم ليان',
    stars: 5,
    text: 'بنتي كانت ترفض تنام لحالها، بعد ما قريناها القصة مع بعض صارت تطلب تنام بغرفتها! شغلة ما توقعتها والله',
    date: '2026-04-28',
    template: 'قلق وقت النوم',
  },
  {
    name: 'أبو يزن',
    stars: 5,
    text: 'طلبت قصة لابني عشان خايف من الكلاب. القصة طلعت تحفة، الرسومات حلوة كتير وابني حبها. صار يحكيلي "بابا أنا زي سامي مش خايف"',
    date: '2026-05-01',
    template: 'الخوف من الكلاب',
  },
  {
    name: 'ريما',
    stars: 5,
    text: 'هدية عيد ميلاد بنتي كانت القصة هاي. لما شافت اسمها ورسمتها بالقصة انبسطت بشكل مش طبيعي، ضلت تقرأها كل يوم',
    date: '2026-04-15',
    template: 'مغامرة عيد الميلاد',
  },
  {
    name: 'أم آدم',
    stars: 5,
    text: 'ابني عنده أخ جديد وصار يغار كتير. القصة ساعدته يفهم إنو مكانته ما تغيرت. أحسن ٣٠ دولار صرفتهم بحياتي',
    date: '2026-05-03',
    template: 'غيرة من أخ جديد',
  },
  {
    name: 'خالد و.',
    stars: 4,
    text: 'فكرة القصة كتير حلوة وابني انبسط فيها. بس تمنيت يكون في أكتر من نسخة للرسومات. بشكل عام تجربة ممتازة',
    date: '2026-04-20',
    template: 'الخوف من الظلام',
  },
  {
    name: 'رنين ب.',
    stars: 5,
    text: 'بنتي كانت تبكي كل ما أوديها عالروضة. بعد القصة صارت تحكيلي "ماما أنا بطلة زي تالا بالقصة". دموعي نزلت من الفرحة',
    date: '2026-05-06',
    template: 'قلق الانفصال',
  },
  {
    name: 'نادية',
    stars: 5,
    text: 'طلبت نسخة ورقية وجاتني بظرف حلو. الجودة ممتازة والورق سميك. ابني حاططها جنب تخته وكل ليلة بدو اياها',
    date: '2026-04-10',
    template: 'الخوف من الإبر',
  },
  {
    name: 'أبو سارة',
    stars: 5,
    text: 'أول مرة بشوف شي زي هيك. بنتي شافت حالها بالرسمة وصارت تضحك. القصة مكتوبة بطريقة ذكية وبتوصل الرسالة بدون ما تحس',
    date: '2026-05-08',
    template: 'أفكار مخيفة',
  },
];

const REVIEWS_HE = [
  {
    name: 'מיכל ר.',
    stars: 5,
    text: 'הבן שלי עומר פחד מכלבים ולא הסכים לצאת לגינה. הזמנתי לו סיפור וכבר באותו ערב הוא ביקש לקרוא אותו שוב. אחרי שבוע הוא ניגש לכלב של השכנים לבד!',
    date: '2026-04-22',
    template: 'פחד מכלבים',
  },
  {
    name: 'גיא כ.',
    stars: 5,
    text: 'קניתי לבת שלי נועה סיפור עם אלזה ליום ההולדת. כשפתחה את החבילה ראתה את עצמה מצוירת בתוך הסיפור ופשוט לא הפסיקה לחייך. שווה כל שקל',
    date: '2026-05-10',
    template: 'הרפתקה עם אלזה',
  },
  {
    name: 'שירה מ.',
    stars: 5,
    text: 'הילדה שלי התחילה גן השנה ובכתה כל בוקר. אחרי שקראנו את הסיפור ביחד היא אמרה "אמא, גם אני אמיצה כמו בסיפור". עכשיו היא נכנסת לגן בחיוך',
    date: '2026-05-02',
    template: 'יום ראשון בגן',
  },
  {
    name: 'אורן ד.',
    stars: 5,
    text: 'הבן שלי איתי מת על כדורגל אז הזמנתי לו את סיפור גביע העולם. הוא קרא אותו שלוש פעמים ברצף ועכשיו הוא משחק בחצר וצועק "אני הגיבור!" מומלץ בטירוף',
    date: '2026-04-30',
    template: 'גיבור גביע העולם',
  },
  {
    name: 'נופר ל.',
    stars: 4,
    text: 'רעיון מקורי ומתנה מיוחדת. האיורים יפהפיים והסיפור מותאם אישית בצורה מרשימה. הייתי שמחה אם היו עוד אפשרויות סגנון, אבל בסך הכל חוויה מעולה',
    date: '2026-04-18',
    template: 'פחד מחושך',
  },
  {
    name: 'טלי ש.',
    stars: 5,
    text: 'נולד לנו תינוק והבת הגדולה הפכה לקנאית ברמות. הסיפור הסביר לה בדרך כזו עדינה שהיא אחות גדולה מדהימה. עכשיו היא רוצה לעזור עם התינוק כל הזמן',
    date: '2026-05-05',
    template: 'קנאה מאח חדש',
  },
  {
    name: 'יניב ג.',
    stars: 5,
    text: 'הזמנתי כריכה קשה והאיכות הפתיעה אותי. הנייר עבה, הצבעים חיים, והגיע באריזה מושקעת. הבן שלי שם את הספר על השידה ולא מוכן לישון בלעדיו',
    date: '2026-04-12',
    template: 'חוקר החלל הצעיר',
  },
  {
    name: 'דנה ע.',
    stars: 5,
    text: 'הבת שלי מאיה אוהבת ספיידרמן ולא מצאתי שום ספר בעברית שמתאים. פה היא ממש הגיבורה של הסיפור, עם השם שלה והתמונה שלה. היא לא מפסיקה לספר לכולם',
    date: '2026-05-12',
    template: 'הרפתקה עם ספיידרמן',
  },
];

const STATS_AR = {
  familyCount: '٢,٤٠٠+',
  storyCount: '٣,٨٠٠+',
  avgRating: '٤.٩',
  reviewCount: '٣٢٠+',
};

const STATS_HE = {
  familyCount: '2,400+',
  storyCount: '3,800+',
  avgRating: '4.9',
  reviewCount: '320+',
};

export function getReviews(lang) {
  return lang === 'he' ? REVIEWS_HE : REVIEWS_AR;
}

export function getStats(lang) {
  return lang === 'he' ? STATS_HE : STATS_AR;
}

export const REVIEWS = REVIEWS_AR;
export const STATS = STATS_AR;
